import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('@chant/home').then(m => m.HomeComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('@chant/auth').then(m => m.AuthComponent)
  },
  {
    path: 'about',
    loadComponent: () => import('@chant/about-us').then(m => m.AboutUsComponent)
  },
  {
    path: 'services',
    loadChildren: () => import('@chant/chant-services').then(m => m.ChantServicesModule)
  },
  {
    path: 'clients',
    loadComponent: () => import('@chant/clients').then(m => m.ClientsComponent)
  },
  {
    path: 'contact',
    loadComponent: () => import('@chant/contact-us').then(m => m.ContactUsComponent)
  },
  {
    path: 'news',
    loadComponent: () => import('@chant/news').then(m => m.NewsComponent)
  },
];
